module.exports = __webpack_public_path__ + "img/img_main_con3.c56efdb0.jpg";